
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import styles from '../core-exchange.module.scss';
export const metadata = {
  toc: false,
  subnav: false,
  title: 'Production readiness',
  layout: 'guide',
  description: 'This page has moved to Post-launch operations',
  parentTocLevel: 2,
  childTocLevel: 3,
  secondLevelToc: false
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className={styles.page}>
      <Header title='Production readiness' subtitle={metadata.description} mdxType="Header" />
      <p>{`This content has been moved. For performance targets, monitoring recommendations, and go-live readiness, see `}<a parentName="p" {...{
          "href": "/core-exchange/docs/post-launch"
        }}>{`Post-launch operations`}</a>{`.`}</p>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
